'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = install;

var _messageBus = require('@wh/message-bus');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utag = null; /* eslint-disable prefer-destructuring, no-console */

var state = 'new';
var promise = null;
var topic = 'wh.analytics.command.interaction.track';
var topicTrackCompleted = 'wh.analytics.event.interaction.track.completed';
var eventQueue = [];

function install() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      jurisdiction = _ref.jurisdiction,
      environment = _ref.environment;

  if (!jurisdiction) {
    var message = 'Invalid configuration, the jurisdiction is not specified.';
    return _promise2.default.reject(new Error(message));
  }
  if (!environment) {
    var _message = 'Invalid configuration, the environment is not specified.';
    return _promise2.default.reject(new Error(_message));
  }
  var jurisdictionToProfileMap = {
    uk: 'uk-web',
    es: 'es-web',
    it: 'it-web'
  };
  var environmentToEnvironmentMap = {
    dev: 'dev',
    stg: 'qa',
    prd: 'prod'
  };
  var targetJurisdiction = jurisdictionToProfileMap[jurisdiction];
  var targetEnvironment = environmentToEnvironmentMap[environment];

  if (!targetJurisdiction) {
    var _message2 = 'Invalid configuration, the allowed jurisdictions are as the following "uk", "es" or "it".';
    return _promise2.default.reject(new Error(_message2));
  }
  if (!targetEnvironment) {
    var _message3 = 'Invalid configuration, the allowed environments are as the following "dev", "stg" or "prd".';
    return _promise2.default.reject(new Error(_message3));
  }
  var url = '//tags.tiqcdn.com/utag/williamhillgroup/' + targetJurisdiction + '/' + targetEnvironment + '/utag.js';
  return installScript(url);
}

var installScript = function installScript(src) {
  if (typeof window === 'undefined') {
    var message = 'Installation failed due to the lack of the browser environment.';
    return _promise2.default.reject(new Error(message));
  }
  if (state === 'done') {
    var _message4 = 'Installation failed, the package is already installed.';
    return _promise2.default.reject(new Error(_message4));
  }
  if (state === 'pending') {
    // enqueue and run again once preceding promise completes
    var again = function again() {
      return installScript(src);
    };
    return promise.then(again).catch(again);
  }
  state = 'pending';
  promise = new _promise2.default(function (resolve, reject) {
    window.utag_cfg_ovrd = {
      noview: true,
      dom_complete: true,
      readywait: true
    };
    var script = window.document.createElement('script');
    script.type = 'text/javascript';
    script.onload = function () {
      utag = window.utag;
      if (isUniversalTagManagerInternallyValid(utag)) {
        state = 'done';
        promise = null;
        resolve();
      } else {
        state = 'new';
        promise = null;
        var _message5 = 'Installation failed due to the integrity violation.';
        reject(new Error(_message5));
      }
    };
    script.onerror = function () {
      state = 'new';
      promise = null;
      var message = 'Installation failed due to the inability to load dependent resources.';
      reject(new Error(message));
    };
    script.src = src;
    window.document.body.insertBefore(script, window.document.body.firstChild);
  });

  var subscriptionId = null;
  promise = promise.then(function (result) {
    eventQueue.forEach(function (msg) {
      return sendEvent(msg.data, function () {
        return trackSuccessfulCallback(msg);
      });
    });
    eventQueue.length = 0;
    return result;
  });
  promise = promise.catch(function (error) {
    eventQueue.length = 0;
    (0, _messageBus.unsubscribe)(subscriptionId);
    throw error;
  });
  subscriptionId = (0, _messageBus.subscribe)({
    topic: topic,
    callback: function callback(msg) {
      if (state === 'done') {
        sendEvent(msg.data, function () {
          return trackSuccessfulCallback(msg);
        });
      } else {
        eventQueue.push(msg);
      }
    }
  });

  return promise;
};

var sendEvent = function sendEvent() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      type = _ref2.type,
      event = _ref2.event;

  var completedCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (!isUniversalTagManagerInternallyValid(utag)) {
    console.error('Tracking kit could not handle tracking event due to the integrity violation.');
    return;
  }
  // cloning is required as utag.view and utag.link mutate dispatched object
  var cloned = event ? JSON.parse((0, _stringify2.default)(event)) : event;
  switch (type) {
    case 'view':
      utag.view(cloned, completedCallback);
      break;

    case 'link':
      utag.link(cloned, completedCallback);
      break;

    default:
      console.error('Tracking kit could not handle "' + type + '" event type, the allowed event types are as following "view" or "link".');
  }
};

var isUniversalTagManagerInternallyValid = function isUniversalTagManagerInternallyValid(utm) {
  return (typeof utm === 'undefined' ? 'undefined' : (0, _typeof3.default)(utm)) === 'object' && Object.prototype.hasOwnProperty.call(utm, 'view') && Object.prototype.hasOwnProperty.call(utm, 'link');
};

var trackSuccessfulCallback = function trackSuccessfulCallback(data) {
  return (0, _messageBus.publish)(topicTrackCompleted, data);
};